import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      form: {
        pinfl: "PINFL",
        dateOfBirth: "Date of Birth",
        language: "Language",
        languages: {
          en: "English",
          ru: "Russian",
          uz: "Uzbek"
        }
      }
    }
  },
  ru: {
    translation: {
      form: {
        pinfl: "ПИНФЛ",
        dateOfBirth: "Дата рождения",
        language: "Язык",
        languages: {
          en: "Английский",
          ru: "Русский",
          uz: "Узбекский"
        }
      }
    }
  },
  uz: {
    translation: {
      form: {
        pinfl: "PINFL",
        dateOfBirth: "Tug'ilgan sana",
        language: "Til",
        languages: {
          en: "Inglizcha",
          ru: "Ruscha",
          uz: "O'zbekcha"
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ru', // default language
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
